

export default class AiOperations {
  static PARAMS = 'Params';

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return true;
  }
  
  
  prompt(params) {
    var event = new AiOperations.Prompt.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static Prompt = {
    Names: {
      Operation: 'LlmPromptQueryOperation',
      Notification: 'AiPromptNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function (params) {
      var event = {
        handler: AiOperations.Prompt.Names.Operation,
        eventName: AiOperations.Prompt.Names.Operation,
      }
      event[AiOperations.PARAMS] = params.data ? params.data : params;
      return event;
    },
  }

  save(params) {
    var event = new AiOperations.Save.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static Save = {
    Names: {
      Operation: 'AiPromptSaveCommandOperation',
      Notification: 'AiPromptNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function (params) {
      var event = {
        handler: AiOperations.Save.Names.Operation,
        eventName: AiOperations.Save.Names.Operation,
      }
      event[AiOperations.PARAMS] = params.data ? params.data : params;
      return event;
    },
  }
  
}